import { buildModelManager } from "../builder.js";
const DefaultScenarioRunSelection = {
  __typename: true,
  id: true,
  audioMetadata: true,
  audioRecording: { url: true, mimeType: true, fileName: true },
  audioTranscription: { markdown: true, truncatedHTML: true },
  cohortId: true,
  completedAt: true,
  createdAt: true,
  debriefMetadata: true,
  debriefRecording: { url: true, mimeType: true, fileName: true },
  debriefTalkingPoints: { markdown: true, truncatedHTML: true },
  debriefTranscription: { markdown: true, truncatedHTML: true },
  instructorId: true,
  runMetadata: true,
  runNotes: { markdown: true, truncatedHTML: true },
  runNumber: true,
  scenarioId: true,
  scenarioShareTokenId: true,
  startedAt: true,
  status: true,
  students: true,
  updatedAt: true
};
const modelApiIdentifier = "scenarioRun";
const pluralModelApiIdentifier = "scenarioRuns";
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultScenarioRunSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultScenarioRunSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultScenarioRunSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultScenarioRunSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultScenarioRunSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultScenarioRunSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultScenarioRunSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createScenarioRun",
    operationReturnType: "CreateScenarioRun",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      scenarioRun: { required: false, type: "CreateScenarioRunInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultScenarioRunSelection
  },
  {
    type: "action",
    operationName: "bulkCreateScenarioRuns",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkCreateScenarioRunsInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultScenarioRunSelection
  },
  {
    type: "action",
    operationName: "updateScenarioRun",
    operationReturnType: "UpdateScenarioRun",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      scenarioRun: { required: false, type: "UpdateScenarioRunInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultScenarioRunSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateScenarioRuns",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpdateScenarioRunsInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultScenarioRunSelection
  },
  {
    type: "action",
    operationName: "deleteScenarioRun",
    operationReturnType: "DeleteScenarioRun",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteScenarioRuns",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "upsertScenarioRun",
    operationReturnType: "UpsertScenarioRun",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      scenarioRun: { required: false, type: "UpsertScenarioRunInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateScenarioRunResult": { hasReturnType: false },
      "... on UpdateScenarioRunResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultScenarioRunSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertScenarioRuns",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpsertScenarioRunsInput!]" }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultScenarioRunSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "scenarioRunGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const ScenarioRunManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultScenarioRunSelection,
  operations
);
export {
  DefaultScenarioRunSelection,
  ScenarioRunManager
};
//# sourceMappingURL=ScenarioRun.js.map
